/* unplugin-vue-components disabled */import script from "./AppItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AppItem.vue?vue&type=script&setup=true&lang=js"

import "./AppItem.vue?vue&type=style&index=0&id=f3b4a72c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3b4a72c"]])

export default __exports__